import React, {useState, useEffect} from 'react'
import Color from '../../Components/Colors/Color'
import CustomSnackbar from "../Components/Snackbar/Snackbar"
import { useNavigate } from 'react-router-dom';
import '../Components/Overlay/Overlay.css'
import ClipLoader from "react-spinners/ClipLoader"
import Product from '../../Models/ProductModels';
import productsData from "../../JSON/products.json"
import '../Styles/AdminHome.css'
import { fetchProducts } from '../Controller/ProductController';

const AdminHome = () => {

    const navigate = useNavigate();

    const [products, setProducts] = useState([]);

    const [loading, setLoading] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [finishFlag, setFinishFlag] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);

    useEffect(() => {
        window.scrollTo(0,0);
    },[])

    useEffect(() => {
        
        const handleFetchProducts = async () => {
            try{
                setLoading(true);
                const response = await fetchProducts();
                const productList = response.data.products;
                console.log(productList);
                const sortedProducts = productList.sort((a, b) => a.name.localeCompare(b.name));
                setProducts(sortedProducts || [])
    
            }catch(error)  {
                    setMessageSnackbar(error?.response?.data?.message || "An error occurred")
                    setSeveritySnackbar("error");
                    setOpenSnackbar(true);
            }finally{
                setLoading(false);
            }
        }
        
        handleFetchProducts();
    },[])

    const handleProductDetal = (product) => {
        navigate(`./product-details?id=${product.id}`);
    }

    const moveToAddProduct = () => {
        navigate('./new-product');
    }

    return(
        <>
            <div className='admin-home-container' style={{backgroundColor: Color.secondaryText}}>
                <div className='admin-home-header-container'>
                    <h4 className='admin-home-header'>
                        Products
                    </h4>
                    <div className='admin-home-add-btn-container'>
                        <span className='admin-home-add-btn fa-solid fa-plus' onClick={moveToAddProduct}></span>
                    </div>
                </div>
                <div className='admin-home-products-container'>
                    <div className={`products-list-container ${products.length ? 'grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 place-items-center gap-10 xl:gap-20 mb-6 ' : ''} `}>
                        
                        {products.length ? products.map((product) => {
                        return(
                        <div className='products-page-card' onClick={() => handleProductDetal(product)}>
                            <Product product = {product} key = {product.id}/>
                        </div>
                        )
                        }) : !loading && <h4 className='admin-home-empty-header' style={{color: Color.thirdText}}>No products found with this keyword. <br/>Please search for another product.</h4>}

                        <div className={`loading-container-overlay-small ${loading ? "" : "stop"}`}>
                            <ClipLoader size={100} color='black' />
                        </div>
                    </div>
                </div>
            </div>

            <CustomSnackbar
                severity={severitySnackbar}
                message={messageSnackbar}
                open={openSnackbar}
                onClose={() => setOpenSnackbar(false)}
                time= {snackbarDuration}
            />
        </>
    )
}

export default AdminHome;